import React from "react";
import CountUpInherit, { CountUpProps } from "react-countup";

const LCountUp: React.FC<CountUpProps> = props => {
    return <CountUpInherit {...props} />;
};

export const CountUp = React.memo(LCountUp, (prev, next) => {
    // console.log("memo");

    const check = [];
    for (const key in prev) {
        check.push(prev[key] === next[key]);
    }

    return check.filter(d => d).length === check.length;
});
